import React, { FC, useEffect } from 'react'
import { Redirect, Route, RouteComponentProps, RouteProps } from 'react-router-dom'
import { useFeatureFlagContext } from 'utils/context/FeatureFlagsContext'
import { useUserDetails } from 'utils/hooks/useUserDetails'
import { setUserContext } from 'utils/tools/airhorn'
import { stepRoutesByName } from '../constants'
import { useUserContext } from '../context'

export interface PrivateRouteProps extends RouteProps {
  requiresOnboarding?: boolean
}

export const PrivateRoute: FC<PrivateRouteProps> = ({ children, requiresOnboarding, ...rest }) => {
  const { error, logout, userDetails } = useUserDetails()
  const { email, id: userId } = userDetails || {}
  const { userFlags } = useUserContext()
  const { getFlag } = useFeatureFlagContext()
  const { enabled: isFmsOnboardingEnabled } = getFlag('fmsOnboarding')

  if (error) {
    logout()
  }

  // Add userId to Datadog context
  useEffect(() => {
    setUserContext({
      id: userId,
      email,
    })
  }, [email, userId])

  if (userId) {
    if (requiresOnboarding && !userFlags.onboardingHasAddedCarriers) {
      // Default value
      const pathname = isFmsOnboardingEnabled ? stepRoutesByName.emailInput : '/onboarding/carrier'

      // If the user is logged
      // If the route requires user to be onboarded & the user isn't
      return <Redirect to={{ pathname }} />
    }
  }

  return (
    <Route
      {...rest}
      render={({ location }: RouteComponentProps) => {
        if (userId) {
          return children
        }

        // Otherwise redirect to login page
        return (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        )
      }}
    />
  )
}
